import paths from 'routing/routes/_paths';

import Integrations from 'views/integrations';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: `${paths.integrations}/:tab(logs|crons)`,
    component: Integrations,
    documentTitle: 'Integrations'
  }
];

export default routes;
